import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions({
      saveAll: 'crudStore/saveAll',
      saveData: 'crudStore/saveData',
    }),
    async actualizarFtn() {
      try {
      } catch {}
    },
    async saveForm(event) {
      try {
        if (this.updateAfiliados) {
          let data = {
            precios_base: this.preciosBase,
            salario_base: 1300000,
            base: this.dataForm[this.namePath].base,
            tabla_precios: this.tablaPrecios.exonerado,
          };
          await this.saveData({ route: 'updateprecios-afiliado', data: data });
        }

        let savePost = false;
        if (event.ftn !== undefined) {
          switch (event.ftn) {
            case 'precios4Ftn':
              let preciosExonerado = _.filter(
                this.dataForm[this.namePath].precios,
                'exonerado'
              );
              if (preciosExonerado.length === 0) {
                await this.updateDataForm({ state: 'precios', data: [] });
                for (let i = 1; i < 6; i++) {
                  await this.pushDataForm({
                    state: 'precios',
                    data: {
                      id: '',
                      id_datos_contacto: 1,
                      id_list_riesgo: i,
                      exonerado: 1,
                      afleps: this.tablaPrecios.exonerado['r' + i].afiliacion,
                      aflccf: this.tablaPrecios.aflCcf,
                      aflafp: this.tablaPrecios.aflAfp,
                      epsarl: this.tablaPrecios.exonerado['r' + i].epsarl.admin,
                      epsarlccf:
                        this.tablaPrecios.exonerado['r' + i].epsarlccf.admin,
                      epsarlafp:
                        this.tablaPrecios.exonerado['r' + i].epsarlafp.admin,
                      epsarlccfafp:
                        this.tablaPrecios.exonerado['r' + i].epsarlccfafp.admin,
                    },
                  });
                }
              } else {
                for (let i = 0; i < preciosExonerado.length; i++) {
                  await this.updateDataForm({
                    state:
                      'precios/' +
                      _.findIndex(this.dataForm[this.namePath].precios, [
                        'id',
                        preciosExonerado[i].id,
                      ]),
                    data: {
                      id: preciosExonerado[i].id,
                      id_datos_contacto: 1,
                      id_list_riesgo: preciosExonerado[i].id_list_riesgo,
                      exonerado: 1,
                      afleps:
                        this.tablaPrecios.exonerado[
                          'r' + preciosExonerado[i].id_list_riesgo
                        ].afiliacion,
                      aflccf: this.tablaPrecios.aflCcf,
                      aflafp: this.tablaPrecios.aflAfp,
                      epsarl:
                        this.tablaPrecios.exonerado[
                          'r' + preciosExonerado[i].id_list_riesgo
                        ].epsarl.admin,
                      epsarlccf:
                        this.tablaPrecios.exonerado[
                          'r' + preciosExonerado[i].id_list_riesgo
                        ].epsarlccf.admin,
                      epsarlafp:
                        this.tablaPrecios.exonerado[
                          'r' + preciosExonerado[i].id_list_riesgo
                        ].epsarlafp.admin,
                      epsarlccfafp:
                        this.tablaPrecios.exonerado[
                          'r' + preciosExonerado[i].id_list_riesgo
                        ].epsarlccfafp.admin,
                    },
                  });
                }
              }
              await this.updateDataPost({
                data: {
                  data: [],
                  route: 'save_all',
                  tablaPost: ['base', 'precios'],
                  tablaDelete: [],
                },
              });

              break;
            case 'precios12Ftn':
              await this.updateDataForm({ state: 'precios', data: [] });
              let preciosNoExonerado = _.filter(
                this.dataForm[this.namePath].precios,
                ['exonerado', false]
              );
              if (preciosNoExonerado.length === 0) {
                await this.updateDataForm({ state: 'precios', data: [] });
                for (let i = 1; i < 6; i++) {
                  await this.pushDataForm({
                    state: 'precios',
                    data: {
                      id: '',
                      id_datos_contacto: 1,
                      id_list_riesgo: i,
                      exonerado: 0,
                      afleps: this.tablaPrecios.noexonerado['r' + i].afiliacion,
                      aflccf: this.tablaPrecios.aflCcf,
                      aflafp: this.tablaPrecios.aflAfp,
                      epsarl:
                        this.tablaPrecios.noexonerado['r' + i].epsarl.admin,
                      epsarlccf:
                        this.tablaPrecios.noexonerado['r' + i].epsarlccf.admin,
                      epsarlafp:
                        this.tablaPrecios.noexonerado['r' + i].epsarlafp.admin,
                      epsarlccfafp:
                        this.tablaPrecios.noexonerado['r' + i].epsarlccfafp
                          .admin,
                    },
                  });
                }
              } else {
                for (let i = 0; i < preciosNoExonerado.length; i++) {
                  await this.updateDataForm({
                    state:
                      'precios/' +
                      _.findIndex(this.dataForm[this.namePath].precios, [
                        'id',
                        preciosNoExonerado[i].id,
                      ]),
                    data: {
                      id: preciosNoExonerado[i].id,
                      id_datos_contacto: 1,
                      id_list_riesgo: preciosNoExonerado[i].id_list_riesgo,
                      exonerado: 0,
                      afleps:
                        this.tablaPrecios.noexonerado[
                          'r' + preciosNoExonerado[i].id_list_riesgo
                        ].afiliacion,
                      aflccf: this.tablaPrecios.aflCcf,
                      aflafp: this.tablaPrecios.aflAfp,
                      epsarl:
                        this.tablaPrecios.noexonerado[
                          'r' + preciosNoExonerado[i].id_list_riesgo
                        ].epsarl.admin,
                      epsarlccf:
                        this.tablaPrecios.noexonerado[
                          'r' + preciosNoExonerado[i].id_list_riesgo
                        ].epsarlccf.admin,
                      epsarlafp:
                        this.tablaPrecios.noexonerado[
                          'r' + preciosNoExonerado[i].id_list_riesgo
                        ].epsarlafp.admin,
                      epsarlccfafp:
                        this.tablaPrecios.noexonerado[
                          'r' + preciosNoExonerado[i].id_list_riesgo
                        ].epsarlccfafp.admin,
                    },
                  });
                }
              }
              await this.updateDataPost({
                data: {
                  data: [],
                  route: 'save_all',
                  tablaPost: ['base', 'precios'],
                  tablaDelete: [],
                },
              });

              break;
          }
        }
        await this.save(event.save, event.savePost);

        if (event.ftn !== undefined) {
          switch (event.ftn && this.updateAfiliados) {
            case 'precios4Ftn':
              await this.saveData({
                route: 'updateprecios-afiliado',
                data: '',
              });
              break;
            case 'precios12Ftn':
              await this.saveData({
                route: 'updateprecios-afiliado',
                data: '',
              });
              break;
          }
        }

        const await1 = await this.resetGlobal({ state: 'openModal' });
        let precios = this.dataForm[this.namePath].precios;
        let base = this.dataForm[this.namePath].base;
        const await2 = this.resetDataForm();
        const await3 = this.updateDataForm({ state: 'precios', data: precios });
        const await4 = this.updateDataForm({ state: 'base', data: base });
        const await5 = this.resetGlobal({ state: 'saveConfig/capa' });
        const await6 = this.resetGlobal({ state: 'saveConfig/saveloading' });
        await Promise.all([await1, await2, await3, await4, await5, await6]);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
